// src/lib/api/client.ts
import { client as generatedClient } from '@/lib/api/generated/client.gen'
import type { Config } from '@/lib/api/generated/client'

// __VITE_API_BASE__ is injected at build time by vite.config.ts
// For production: set to full gateway URL (e.g., https://gateway.dxx.ycsan.com)
// For local dev: empty string, nginx proxy handles routing
declare const __VITE_API_BASE__: string;
const BASE_URL = __VITE_API_BASE__ || ''

export const apiClient = generatedClient

apiClient.setConfig({
  baseUrl: BASE_URL,
} as Config)

apiClient.interceptors.request.use(async (request) => {
  const token = localStorage.getItem('tenant_token') || localStorage.getItem('token')
  if (token) {
    const headers = new Headers(request.headers)
    headers.set('Authorization', `Bearer ${token}`)
    return new Request(request, { headers })
  }
  return request
})

apiClient.interceptors.response.use(async (response) => {
  // 检查是否是登录请求，登录失败不应该触发全局401处理
  const url = response.url || ''
  const isLoginRequest = url.includes('/login') || url.includes('/auth')
  
  if (response.status === 401 && !isLoginRequest) {
    localStorage.removeItem('tenant_token')
    localStorage.removeItem('token')
    // 自动跳转到portal首页
    window.location.href = '/'
  }
  return response
})

export default apiClient


